import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { callTrailerFacts } from "../subjects/stopEvent/callTrailerFacts";
import { stopEventRefs } from "../subjects/stopEvent/refs";

/**
 * The driver's call at a stop where a trailer was picked up or kept.
 */
export const loadedCallV1 = tmsEventKind(
  { category: "call", kind: "loadedCall", version: 1 },
  {
    refs: stopEventRefs,
    facts: {
      stopName: z.string(),
      city: z.string().nullable(),
      /** The trailer the driver left with. */
      trailerNumber: z.string().nullable(),
    },
  },
);

export const LoadedCallV1Schema = loadedCallV1.schema;
export const LoadedCallV1FactsSchema = loadedCallV1.facts;

export type LoadedCallV1 = z.infer<typeof LoadedCallV1Schema>;
export type LoadedCallV1Facts = z.infer<typeof LoadedCallV1FactsSchema>;

/**
 * Version 2: the same call, with both sides of the trailer exchange in place of the one departing trailer.
 */
export const loadedCallV2 = tmsEventKind(
  { category: "call", kind: "loadedCall", version: 2 },
  { refs: stopEventRefs, facts: callTrailerFacts },
);

export const LoadedCallV2Schema = loadedCallV2.schema;
export const LoadedCallV2FactsSchema = loadedCallV2.facts;

export type LoadedCallV2 = z.infer<typeof LoadedCallV2Schema>;
export type LoadedCallV2Facts = z.infer<typeof LoadedCallV2FactsSchema>;

/** Every version of `loadedCall`, keyed by version. What `catalog.ts` places under `call`. */
export const loadedCall = { 1: loadedCallV1, 2: loadedCallV2 } as const;
